module.exports = {"yytx08":{"daobanList":[{"title":"1:是否办理一次性工伤医疗补助金申请","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、工伤保险待遇申请表","state":"必要"},{"name":"2、领取一次性工伤医疗补助金权利义务告知书","state":"必要"},{"name":"3、工伤保险先行支付申请表","state":"非必要"},{"name":"4、解除或终止劳动关系证明","state":"必要"},{"name":"5、法院出具的中止执行文书","state":"必要"},{"name":"6、工伤职工具有金融功能的社会保障卡","state":"必要"},{"name":"7、代办委托书","state":"必要"},{"name":"8、本人工资材料","state":"必要"},{"name":"9、用人单位被依法吊销营业执照或者撤销登记、备案的证明材料","state":"必要"},{"name":"10、工伤职工催告用人单位支付而用人单位未支付或部分支付的情况说明及相关催告证明材料","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx08.json
// module id = 1307
// module chunks = 0